import * as React from "react";
const Download = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.2896 8.06128L10.097 12.2539L5.9043 8.06128"
      stroke="#FF6A4B"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M10.0977 0.99585L10.0977 11.1379"
      stroke="#FF6A4B"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M19 10.0039C19 14.9764 15.625 19.0039 10 19.0039C4.375 19.0039 1 14.9764 1 10.0039"
      stroke="#FF6A4B"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Download;
